import * as THREE from 'three'
import React, { useRef } from 'react'
import { Canvas, useFrame, useThree } from '@react-three/fiber'
import { ContactShadows } from '@react-three/drei'
import './styles.css'
import Model from "./Pyramid";

// function Box({ text, color, ...props }) {
//   const [hovered, set] = useState(false)
//   return (
//     <mesh {...props} onPointerOver={(e) => set(true)} onPointerOut={(e) => set(false)}>
//       <boxGeometry args={[2, 2, 2]} />
//       <meshStandardMaterial color={hovered ? 'hotpink' : color} />
//       <Html position={[0, 0, 1]} className="label" center>
//         {text}
//       </Html>
//     </mesh>
//   )
// }

function ScrollContainer({ scroll, children }) {
  const { viewport } = useThree()
  const group = useRef()
  useFrame((state, delta) => {
    group.current.position.y = THREE.MathUtils.damp(group.current.position.y, viewport.height * scroll.current, 4, delta)
    // Or: group.current.position.lerp(vec.set(0, viewport.height * scroll.current, 0), 0.1)
  })
  return <group ref={group}>{children}</group>
}

function Scene(scroll) {
  const viewport = useThree((state) => state.viewport)
  return (
    <>
      {/* <Box text={<h1>This is HTML</h1>} color="aquamarine" /> */}
      <Model text={
        "Soon™"
        } 
        textClass={"contentd3"}
        position={[1, -viewport.height / 4, 0]} scroll={scroll}/>
      {/* <Box text={<h1>H1 caption</h1>} color="lightblue" position={[0, -viewport.height, 0]} /> */}
    </>
  )
}




export default function Htmltie() {
  const scrollRef = useRef()
  const scroll = useRef(0)
  return (
    <>
      <Canvas
        style={{
            position: "fixed",
            top: 125,
            left: 0,
            zIndex: -99,
        }}
        shadows
        onCreated={(state) => state.events.connect(scrollRef.current)}
        raycaster={{ computeOffsets: ({ clientX, clientY }) => ({ offsetX: clientX, offsetY: clientY }) }}>
        {/* <color attach="background" args={['black']} /> */}
        <hemisphereLight color="#ffffff" groundColor="#b9b9b9" position={[-7, 25, 13]} intensity={0.85} />
        <ContactShadows rotation-x={Math.PI / 2} position={[0, -35, 0]} opacity={0.25} width={200} height={200} blur={1} far={50} />
        <pointLight color="indianred" />
        <directionalLight position={[10, 10, -10]} color="orange" />
        <ScrollContainer scroll={scroll}>
          <Scene scroll={scroll} />
        </ScrollContainer>
      </Canvas>
      <div
        ref={scrollRef}
        onScroll={(e) => (scroll.current = e.target.scrollTop / (e.target.scrollHeight - e.target.clientHeight))}
        className="scroll">
        <div style={{ height: `200vh`, pointerEvents: 'none' }}></div>
      </div>
    </>
  )
}